import { render, staticRenderFns } from "./background.vue?vue&type=template&id=dedf7d24&scoped=true&"
import script from "./background.vue?vue&type=script&lang=js&"
export * from "./background.vue?vue&type=script&lang=js&"
import style0 from "./background.vue?vue&type=style&index=0&id=dedf7d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedf7d24",
  null
  
)

export default component.exports